import { mockComponent } from 'bloko/common/setupMockComponents';

const { LoadingScale, LoadingColor } = jest.requireActual('bloko/blocks/loading/index.js');
export { LoadingScale, LoadingColor };

export default mockComponent('Loading');
